import React from 'react';
import { Mail, Phone, UserRound } from 'lucide-react';
import Card from 'tailwind-components/Card/Card';
import Button from 'tailwind-components/Button/Button';
import useAgentOwner from 'tailwind-components/Sidebar/useAgentOwner';
import { cn } from 'lib/utils';
import { isMobileWebView, postMobileOpenUrl } from 'helpers/mobileWebView';

const detailRowClassName =
  'flex min-w-0 items-center gap-2 text-xs text-grey [&_svg]:size-3.5 [&_svg]:shrink-0 [&_svg]:text-grey-light';

/**
 * contracting specialist assigned to the agent, rendered as the top card of the sunshine
 * home sidebar with direct contact shortcuts
 */
export default function ConsultantCard() {
  const owner = useAgentOwner();

  if (!owner.isReady) return null;

  const handleBooking = () => {
    if (isMobileWebView()) {
      postMobileOpenUrl(owner.bookingUrl);
      return;
    }
    window.open(owner.bookingUrl, '_blank');
  };

  return (
    <Card
      variant='elevated'
      title='My Contracting Specialist'
      icon={<UserRound aria-hidden />}
      className='shrink-0'
    >
      <div className='flex min-w-0 items-center gap-3'>
        <img
          src={owner.imageSrc}
          alt={owner.displayName}
          className={cn(
            'size-14 shrink-0 rounded-full object-contain ring-2 ring-primary-lighter',
            owner.isTeamPhoto && 'object-cover'
          )}
        />
        <div className='flex min-w-0 flex-col gap-1'>
          <p className='m-0 truncate text-sm font-bold leading-none text-primary'>
            {owner.displayName}
          </p>
          <span className={detailRowClassName}>
            <Mail aria-hidden />
            <span className='truncate'>{owner.displayEmail}</span>
          </span>
          <span className={detailRowClassName}>
            <Phone aria-hidden />
            <span className='truncate'>{owner.displayPhone}</span>
          </span>
        </div>
      </div>

      <div className='flex flex-wrap gap-2'>
        {owner.hasEmail && (
          <a
            href={`mailto:${owner.displayEmail}`}
            className='min-w-0 flex-1 no-underline'
          >
            <Button
              fill
              text='Send Email'
              size='small'
              rounded='medium'
              variant='primaryLight'
            />
          </a>
        )}
        {owner.bookingUrl && (
          <Button
            fill
            outlined
            text='Book a call'
            size='small'
            rounded='medium'
            variant='secondary'
            className='min-w-0 flex-1'
            onClick={handleBooking}
          />
        )}
      </div>
    </Card>
  );
}
